export default {
  bio: "profile",
  update: "profile/update",
};
